import { CSSProperties, FC } from 'react';

export interface SvgRecorderCloseProps {
  size?: string; // size of square container
  style?: CSSProperties; // not for height or width
  className?: string;
}

export const SvgRecorderClose: FC<SvgRecorderCloseProps> = ({
  size = '24px',
  style,
  className,
}) => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...style,
      height: size,
      width: size,
    }}
    className={className}
  >
    <div
      style={{
        position: 'relative',
        height: 0,
        width: '100%',
        padding: 0,
        paddingBottom: '100%',
      }}
    >
      <svg
        style={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          left: 0,
          top: 0,
        }}
        viewBox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.989 11.412L8.225 6.65l4.764-4.764A1.116 1.116 0 0011.413.308L6.649 5.074 1.885.308A1.114 1.114 0 00.31 1.883l4.764 4.766-4.766 4.765a1.114 1.114 0 001.575 1.575l4.766-4.765 4.764 4.765a1.116 1.116 0 001.576-1.576"
          fill="#FFF"
          fillRule="evenodd"
        />
      </svg>
    </div>
  </div>
);
